<script>
    export let height = "18";
    export let width = "16";

    export let fill = "#ff0000;"
</script>

<button on:click type="button" aria-label="Close">
    <svg fill="{fill}" width="{width}" height="{height}" viewBox="0 0 44 44" aria-hidden="true" focusable="false">
        <path d="M0.549989 4.44999L4.44999 0.549988L43.45 39.55L39.55 43.45L0.549989 4.44999Z" />
        <path d="M39.55 0.549988L43.45 4.44999L4.44999 43.45L0.549988 39.55L39.55 0.549988Z" />
    </svg>
</button>

<style>
    button {
        background-color: transparent;
        border: 0;
    }
</style>